import type { MutableRefObject } from 'react';

import type { Line } from '../../../../components/tools/clouds/types';
import { PsyToolsId } from '../../../../components/meet/tools-panel/types';
import { setActiveTool } from '../../../../store/meetActiveTool.slice';
import type { MeetOverlaysBridgeApi } from '../../MeetOverlaysProvider';
import type { MeetToolsBridgeApi } from '../../MeetToolsProvider';

export interface CloudsRoomHandlersArgs {
  isPsychologist: boolean;
  dispatch: (action: unknown) => void;
  overlaysApiRef: MutableRefObject<MeetOverlaysBridgeApi | null>;
  toolsApiRef: MutableRefObject<MeetToolsBridgeApi | null>;
}

export interface CloudsRoomHandlers {
  onCloudsOpen: () => void;
  onCloudsClose: () => void;
  onCloudsDrawLine: (line: Line) => void;
  onCloudsClearDrawing: () => void;
  onCloudsSelectImage: (imageIndex: number) => void;
  onCloudsClientFinished: () => void;
  onCloudsUndo: (linesCount: number) => void;
}

export function createCloudsRoomHandlers({
  isPsychologist,
  dispatch,
  overlaysApiRef,
  toolsApiRef,
}: CloudsRoomHandlersArgs): CloudsRoomHandlers {
  return {
    onCloudsOpen: () => {
      if (!isPsychologist) {
        if (window.innerHeight > window.innerWidth) {
          overlaysApiRef.current?.setShowModalInstruct(
            'Психолог активировал инструмент "Облака". Использовать его на телефоне не рекомендуется — удобнее рисовать на ноутбуке, компьютере или планшете, где экран больше.',
          );
        }

        dispatch(setActiveTool(PsyToolsId.CLOUDS));
      }

      toolsApiRef.current?.setCloudsClientFinished(false);
      toolsApiRef.current?.setCloudsSelectedImage(null);
      toolsApiRef.current?.setCloudsLines([]);
    },

    onCloudsClose: () => {
      if (!isPsychologist) {
        dispatch(setActiveTool(0));
      }

      toolsApiRef.current?.setCloudsClientFinished(false);
      toolsApiRef.current?.setCloudsSelectedImage(null);
      toolsApiRef.current?.setCloudsLines([]);
    },

    onCloudsDrawLine: (line: Line) => {
      toolsApiRef.current?.setCloudsLines((prev) => [...prev, line]);
    },

    onCloudsClearDrawing: () => {
      toolsApiRef.current?.setCloudsLines([]);
    },

    onCloudsSelectImage: (imageIndex: number) => {
      toolsApiRef.current?.setCloudsSelectedImage(imageIndex);
      toolsApiRef.current?.setCloudsLines([]);
    },

    onCloudsClientFinished: () => {
      toolsApiRef.current?.setCloudsClientFinished(true);
    },

    onCloudsUndo: (linesCount: number) => {
      toolsApiRef.current?.setCloudsLines((prev) => {
        if (linesCount <= 0 || linesCount > prev.length) {
          return prev;
        }

        return prev.slice(0, prev.length - linesCount);
      });
    },
  };
}

